import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../services/CamplaCoreService";
import LecturerDashboard from "./lecturerDashboard/LecturerDashboard";
import AdminDashboard from "./adminDashboard/AdminDashboard";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      examinations: [],
      moduleClasses: [],
      user: null
    };
    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    this.setState({ user: CamplaCoreService.getAuthenticatedUser() });
    this.setState(await CamplaCoreService.getExtendedExaminations());
  }

  render() {
    const { t } = this.props;
    let roleBasedDashboard = "";
    if (this.state.user) {
      if (this.state.user.role === 0) {
        roleBasedDashboard = (
          <LecturerDashboard
            user={this.state.user}
            examinations={this.state.examinations}
            moduleClasses={this.state.moduleClasses}
            classesCount={this.state.classesCount}
          />
        );
      } else if (this.state.user.role === 1) {
        roleBasedDashboard = (
          <AdminDashboard
            user={this.state.user}
            examinations={this.state.examinations}
            moduleClasses={this.state.moduleClasses}
            classesCount={this.state.classesCount}
          />
        );
      }
    }
    return (
      <Container className="mt-3">
        <Row className="pageTitle">
          <Col>
            <h2>{t("Dashboard.Title")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>{roleBasedDashboard}</Col>
        </Row>
      </Container>
    );
  }
}

export default withTranslation()(Dashboard);
